/**
 * Textos (`en`) de planta d'Existències (OBR-14 estats de lot, OBR-143 caducitat a la recepció): namespace `planta.stock`.
 * Tall propi: no es toca `ca.ts`. Les tres llengües han de tenir les mateixes claus (i18n.test.ts). Vocabulari: «Existències», mai «Stock».
 */

export const plantaStockEn = {
  'planta.stock': {
    writtenReason: 'Reason: {{reason}}',
    blockedQuantity: 'Blocked: {{quantity}}',
    expiredOn: 'Expired on {{date}}',
    unavailableTitle: 'Lots that cannot be used',
    unavailableHint: 'Blocked and expired lots are neither proposed nor selectable.',
    allLotsUnavailable:
      'This article’s lots are blocked or expired: they cannot be used. A manager can unblock them from the BackOffice.',
    scanLotBlocked: 'Lot {{lot}} is blocked and cannot be used.',
    scanLotBlockedReason: 'Lot {{lot}} is blocked ({{reason}}) and cannot be used.',
    scanLotExpired: 'Lot {{lot}} is expired and cannot be used.',
    statesUnchecked:
      'Could not check which lots are blocked. Check before using any of them.',
    statesStale:
      'Lot states have not been updated for more than a day. Check that no lot is blocked.',

    expiryLabel: 'Expiry',
    expiryMissing: 'This entry has no expiry date.',
    expiryUseEstimate: 'Use an estimated expiry',
    expiryMissingSummary_one: '{{count}} entry has no expiry date. Add it or use an estimated one.',
    expiryMissingSummary_other:
      '{{count}} entries have no expiry date. Add it or use an estimated one.',
    confirmWithoutExpiry: 'Confirm without expiry',
    confirmWithoutExpiryHint:
      'If you do not know it, you can confirm anyway: the goods come in and the stock is listed under “To regularize” until an expiry date is added.',
  },
} as const;
